import { Link, useLocation } from "react-router-dom"
import EntStaffSummary from "../EntStaffSummary"
import OrgStaffSummary from "../OrgStaffSummary"

export default function StaffGroupSidebar() {
  const location = useLocation()
  const ORG_STAFF_LIST_PATH = "/organization/staff"
  const ENT_STAFF_LIST_PATH = "/enterprise/staff"
  const GROUP_SUPERVISION_PATH = "/supervision/group-session"

  const isOrganizationStaffRoute = location.pathname === ORG_STAFF_LIST_PATH
  const isEnterpriseStaffRoute = location.pathname === ENT_STAFF_LIST_PATH

  const renderActionButton = (to, label) => (
    <Link
      to={to}
      className="btn"
      style={{
        width: "100%",
        marginBottom: "12px",
        justifyContent: "center",
      }}
    >
      <i className="pi pi-plus" />
      {label}
    </Link>
  )

  return (
    <>
      {isEnterpriseStaffRoute ? <EntStaffSummary /> : <OrgStaffSummary />}

      {isOrganizationStaffRoute &&
        renderActionButton("/organization/form/staff/1/", "Add new member")}
      {isEnterpriseStaffRoute &&
        renderActionButton("/enterprise/form/staff/1/", "Add new member")}
      {location.pathname === GROUP_SUPERVISION_PATH &&
        renderActionButton(
          "/form/group_supervision_session/1",
          "Start new Group Supervision Session",
        )}
    </>
  )
}
